<template>
  <Breadcrumbs main="Eventos" title="Formularios de Inscripción" />
  <div class="container-fluid">
    <router-view v-slot="{ Component }">
      <template v-if="Component && $route.name === 'Crear Formulario'">
        <component :is="Component" @formCreated="handleFormCreated" />
      </template>
      <template v-else>
        <div class="row project-cards">
          <TopMenu
            @formCreated="reloadTable"
            @viewChanged="handleViewChange"
            @searchChanged="handleSearchChange"
            @filterChanged="handleFilterChange"
            :currentView="currentView"
          />
          <component
            :is="currentTableComponent"
            ref="tableRef"
            :items="filteredItems"
            :loading="loading"
            @stateChanged="handleStateChange"
          />
        </div>
      </template>
    </router-view>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import axios from "@/includes/connection";
import { toast } from "vue3-toastify";
import TopMenu from "./components/TopMenu.vue";
import Table from "./components/Table.vue";
import TableMyForms from "./components/TableMyForms.vue";

const route = useRoute();

const tableRef = ref(null);
const $route = useRoute();
const currentView = ref("mis-formularios");
const searchQuery = ref("");
const selectedFilter = ref("Sin Filtro");
const allForms = ref([]);
const loading = ref(false);
const userId = parseInt(localStorage.getItem("userId"));

const currentTableComponent = computed(() => {
  return currentView.value === "mis-formularios" ? TableMyForms : Table;
});

const viewFilteredItems = computed(() => {
  if (currentView.value === "mis-formularios") {
    return allForms.value.filter((form) => {
      const formUserId = parseInt(form.user_id);
      return formUserId === userId;
    });
  } else {
    return allForms.value.filter((form) => form.state === true);
  }
});

const filteredItems = computed(() => {
  let filtered = viewFilteredItems.value;

  if (searchQuery.value.trim()) {
    const query = searchQuery.value.toLowerCase().trim();
    filtered = filtered.filter(
      (item) =>
        item.detail.toLowerCase().includes(query) ||
        item.description.toLowerCase().includes(query) ||
        item.user.toLowerCase().includes(query)
    );
  }

  if (selectedFilter.value !== "Sin Filtro") {
    filtered = filtered.filter((item) => item.type === selectedFilter.value);
  }

  return filtered.sort((a, b) => new Date(b.id) - new Date(a.id));
});

function loadItems() {
  loading.value = true;
  axios
    .get("/enrollment-form")
    .then((response) => {
      if (response.data) {
        allForms.value = response.data;
      }
    })
    .catch((error) => {
      console.error("Error loading forms:", error);
      toast.error("Error al cargar los formularios");
    })
    .finally(() => {
      loading.value = false;
    });
}

function handleStateChange(formId) {
  axios
    .patch(`/enrollment-form/${formId}`)
    .then((response) => {
      toast.success("Estado del formulario actualizado exitosamente!");
      loadItems();
    })
    .catch((error) => {
      console.error("Error updating state:", error);
      toast.error("Error al actualizar el estado del formulario");
    });
}

function reloadTable() {
  loadItems();
}

function handleFormCreated() {
  loadItems();
}

watch(
  () => route.name,
  (newRoute) => {
    if (
      newRoute === "Formularios de Inscripción" &&
      localStorage.getItem("formCreatedFlag") === "true"
    ) {
      localStorage.removeItem("formCreatedFlag");
      loadItems();
    }
  }
);

function handleViewChange(view) {
  currentView.value = view;
  searchQuery.value = "";
  selectedFilter.value = "Sin Filtro";
}

function handleSearchChange(query) {
  searchQuery.value = query;
}

function handleFilterChange(filter) {
  selectedFilter.value = filter;
}

onMounted(() => {
  loadItems();
});
</script>
